import { render, staticRenderFns } from "./ProductOptionItem.vue?vue&type=template&id=a275ba5e&scoped=true&"
import script from "./ProductOptionItem.vue?vue&type=script&lang=js&"
export * from "./ProductOptionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a275ba5e",
  null
  
)

export default component.exports